<div class="title-area">
  <h2 mat-subheader class="title">アカウント管理</h2>
  <div class="title-sub-row">
    <div class="title-desc">
      アカウント作成用URL ：
      <a (click)="openSignupUrl()">
        {{ Constant.unionestSignupUrl }}{{ companyCode }}
      </a>
    </div>
    <permission-info></permission-info>
  </div>
</div>

@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <table class="account-content">
    <tr>
      <th class="user_id">ID</th>
      <th class="name">名前</th>
      <th class="affiliation">担当</th>
      <th class="comment">申請コメント</th>
      <th class="user_authority">役職/権限</th>
      <th class="encrypted_password">パスワード</th>
      <th class="last_access_date">最終アクセス</th>
      <th class="btn-edit">Menu</th>
    </tr>
    @for (account of accounts; track account.id; let idx = $index) {
      <tr>
        <td class="user_id">
            {{ account.user_id }}
        </td>
        <td class="name">
          {{ account.last_name }} {{ account.firstName }}
        </td>
        <td class="affiliation">
          <div class="cell-scroll">
            <div class="cell-inner">
              <div class="selected-orgs" *ngIf="account.organizations?.length || account.concurrent_organizations?.length">
                <div *ngFor="let org of account.organizations" class="org-item">
                  ・{{ org.level === 0 
                      ? org.path 
                      : getMasterTypeName(org.master_type) + ' ' + org.path }}
                </div>
                <div *ngFor="let con_org of account.concurrent_organizations" class="org-item">
                  ・専門部 {{ con_org.path }}
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="comment">
          <div class="cell-scroll">
            <div class="cell-inner">
              {{ account.comment }}
            </div>
          </div>
        </td>
        <td class="user_authority">
          <div class="role-name">{{ account.officialposition_name }}</div>
          <div class="authority-label" *ngIf="account.is_master_account">権限：管理（固定）</div>
          <div class="authority-label" *ngIf="!account.is_master_account" [ngSwitch]="account.user_authority">
            <span *ngSwitchCase="0">権限：管理</span>
            <span *ngSwitchCase="1">権限：準管理</span>
            <span *ngSwitchCase="2">権限：運用</span>
            <span *ngSwitchCase="3">権限：メンバー</span>
            <span *ngSwitchDefault>
              権限：なし<span class="unauthorized">（未承認）</span>
            </span>
          </div>
        </td>
        <td class="encrypted_password">
          <div
            [class.masked]="!account.encrypted_password"
            [class.reset-password]="account.encrypted_password"
          >
            {{ account.encrypted_password || '***' }}
          </div>
          @if (account.password_updated_at) {
            <div
              class="password-expire"
              [class.expired]="isPasswordExpired(account.password_updated_at)"
            >
              {{ getPasswordExpireText(account.password_updated_at) }}
            </div>
          }
        </td>
        <td class="last_access_date">{{ account.last_access_date ? formatDate(account.last_access_date) : '' }}</td>
        <td class="btn-edit">
          @if (!account.is_master_account) {
            <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-btn" (keydown.enter)="$event.preventDefault()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu" overlapTrigger="false" class="account-row-menu">
              <button mat-menu-item (click)="onEdit(idx)" (keydown.enter)="$event.preventDefault()" >役職変更</button>
              <button mat-menu-item (click)="onPasswordReset(idx)" (keydown.enter)="$event.preventDefault()">パスワードリセット</button>
              <button mat-menu-item (click)="onDel(idx)" (keydown.enter)="$event.preventDefault()">削除</button>
            </mat-menu>
          }
        </td>
      </tr>
    }
  </table>

  <!-- タブレット・SP（1023px以下）：表の代わりに、1人1枚のカードで表示する（表は非表示） -->
  <div class="account-cards">
    @for (account of accounts; track account.id; let idx = $index) {
      <div class="account-card">
        <div class="card-head">
          <div class="card-head-text">
            @if (account.officialposition_name) {
              <div class="card-role">{{ account.officialposition_name }}</div>
            }
            <div class="card-name">{{ account.last_name }} {{ account.firstName }}</div>
            <div class="card-id">ID：{{ account.user_id }}</div>
          </div>
          @if (!account.is_master_account) {
            <button mat-icon-button [matMenuTriggerFor]="cardMenu" class="card-menu-btn" aria-label="メニュー" (keydown.enter)="$event.preventDefault()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #cardMenu="matMenu" overlapTrigger="false" xPosition="before" class="account-row-menu">
              <button mat-menu-item (click)="onEdit(idx)" (keydown.enter)="$event.preventDefault()">役職変更</button>
              <button mat-menu-item (click)="onPasswordReset(idx)" (keydown.enter)="$event.preventDefault()">パスワードリセット</button>
              <button mat-menu-item (click)="onDel(idx)" (keydown.enter)="$event.preventDefault()">削除</button>
            </mat-menu>
          }
        </div>
        <div class="card-body">
          <div class="card-label">権限</div>
          <div class="card-value">
            @if (account.is_master_account) {
              管理（固定）
            } @else if (getAuthorityName(account.user_authority); as authName) {
              {{ authName }}
            } @else {
              なし<span class="unauthorized">（未承認）</span>
            }
          </div>

          <div class="card-label">担当</div>
          <!-- 担当は3行分までの高さで、超える分は枠内でスクロールする（表の担当列と同じ） -->
          <div class="card-value card-scroll">
            @for (org of account.organizations; track $index) {
              <div class="org-item">・{{ org.level === 0 ? org.path : getMasterTypeName(org.master_type) + ' ' + org.path }}</div>
            }
            @for (con_org of account.concurrent_organizations; track $index) {
              <div class="org-item">・専門部 {{ con_org.path }}</div>
            }
          </div>

          @if (account.comment) {
            <div class="card-label">申請コメント</div>
            <!-- 申請コメントも3行分までの高さで、超える分は枠内でスクロールする -->
            <div class="card-value card-scroll">{{ account.comment }}</div>
          }

          <div class="card-label">パスワード</div>
          <div class="card-value">
            <span [class.reset-password]="account.encrypted_password">{{ account.encrypted_password || '***' }}</span>
            @if (account.password_updated_at) {
              <span class="password-expire card-expire" [class.expired]="isPasswordExpired(account.password_updated_at)">
                {{ getPasswordExpireText(account.password_updated_at) }}
              </span>
            }
          </div>

          <div class="card-label">最終アクセス</div>
          <div class="card-value">{{ account.last_access_date ? formatDate(account.last_access_date) : '' }}</div>
        </div>
      </div>
    }
  </div>
}

@if (!showSpinner && accounts && accounts.length == 0) {
  <div
    class="no-accounts"
    >
  </div>
}
